module.exports = __webpack_public_path__ + "img/chart.3b61174c.png";